import gql from 'graphql-tag';
import memberFragment from './fragments/memberFragment';

export default gql`
  ${memberFragment}
  query getLiveUser {
    user: Member {
      ...memberFragment
    }
  }
`;
